import { render, staticRenderFns } from "./CreatePasswordForm.vue?vue&type=template&id=6400a9ee&scoped=true&"
import script from "./CreatePasswordForm.vue?vue&type=script&lang=js&"
export * from "./CreatePasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./CreatePasswordForm.vue?vue&type=style&index=0&id=6400a9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400a9ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInputPassword: require('/workspace/components/Form/FormInputPassword.vue').default,FormInput: require('/workspace/components/Form/FormInput.vue').default})
